<template lang="html">
  <ul class="serve-section">
    <serviceItem
      v-for="(service, i) in items"
      :service="service"
      :key="service.id"
      :index="i"
    ></serviceItem>
  </ul>
</template>

<script>
import serviceItem from './serviceItem'

export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  components: {
    serviceItem
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.serve-section {
  display: block;
}
</style>
